module.exports = __webpack_public_path__ + "assets/TB-APP_button_arrow_back-24px.svg";